import $ from 'jquery';
import EventsLoggingService from 'js/EventsLoggingService';
import coordinatesUtils from '../../client/utils/coordinates';
import MapLoad from 'client/directives/MapLoad';
import templateAuto from 'client/components/auto/auto.html';
import templateAutoConsole from 'client/components/auto-console/auto-console.html';
import { autoCompleteOptions } from '../data/gm-auto-complete.json';

const { EventTypes } = EventsLoggingService;

var directives = angular.module('myp.directives', []);

directives.directive('mapload', ['$rootScope', MapLoad]);

directives.directive('mapfocus', function () {
    return {
        link: function (scope, element) {
            element[0].focus();
        }
    };
});

directives.directive('delayRadius', function ($timeout, $q) {
    return {
        restrict: 'EA',
        template: ' <input type="text" name="radius" class="radius-input" ng-model="radius" data-ng-init="radius=devFilter" ng-change="modelChanged()"">',
        link: function (scope) {
            scope.modelChanged = function () {
                scope.radius = scope.radius.replace(/\D+/g, '').replace(/^0+/g, 0);

                var firstTimeout = $timeout(function () {
                    if (isNaN(scope.radius) || scope.radius === "" || scope.radius === null) {
                        scope.radius = 0;
                    }
                    if (scope.radius > 1500) {
                        scope.radius = 1500;
                    }
                }, 1500);

                var secondTimeout = $timeout(function () {
                    if (scope.lastSearch !== scope.radius) {
                        if (scope.delayedMethod) {
                            scope.lastSearch = scope.radius;
                            scope.delayedMethod({ radius: scope.radius });
                        }
                    }
                }, 2200);

                // Use $q to make sure the second $timeout waits for the first one
                $q.all([firstTimeout, secondTimeout]).then(function () {
                    // console.log("Both timeouts completed");
                });
            };
        },
        scope: {
            devFilter: '=',
            delayedMethod: '&'
        }
    };
});


directives.directive('googlePlace', function () {
    return {
        require: 'ngModel',
        scope: { findLocationWithPlaces: '&callbackFn' },
        link: function (scope, element) {
            scope.gPlace = new google.maps.places.Autocomplete(element[0],
                autoCompleteOptions);
            google.maps.event.addListener(scope.gPlace, 'place_changed', function () {
                scope.findLocationWithPlaces({ googlePlaceObj: scope.gPlace });
            });
        }
    };
});
directives.directive('googleplaceConsole', function () {
    return {
        require: 'ngModel'
    };
});

directives.directive('formAutofillFix', function () {
    return function (scope, element, attrs) {
        if (attrs.ngSubmit) {
            setTimeout(function () {
                element.unbind('submit').bind('submit', (function (e) {
                    e.preventDefault();
                    element.find('input').triggerHandler('change');
                    scope.$apply(attrs.ngSubmit);
                }));
            }, 0);
        }
    }
});

directives.directive('map', function () {
    return {
        restrict: "E",
        replace: true,
        template: '<div id="map-canvas"></div>'
    };
});

directives.directive('auto', function () {
    return {
        restrict: "E",
        replace: true,
        template: templateAuto,
        link: (scope, element) => {
            const inputSearch = element.find('input');

            element
                .find('button')
                .on('click', () => {
                    const inputString = inputSearch.val();

                    if (inputString) {
                        const fakedPlace = {
                            getPlace: () => {
                                return {
                                    name: inputString,
                                };
                            }
                        };

                        scope.findLocationWithPlaces(fakedPlace);
                    }
                });
        }
    };
});

directives.directive('autoConsole', ['Maps', '$location', 'ngDialog', function (Maps, $location, ngDialog) {
    return {
        restrict: "E",
        replace: true,
        template: templateAutoConsole,
        link: function (scope, element) {
            const elSearch = $('#search1', element);
            const autocomplete = new google.maps.places.Autocomplete(elSearch.get(0), autoCompleteOptions);
            const recenterOnGeometry = function (gps) {
                const lat = gps[0];
                const lng = gps[1];
                const address = elSearch.val();

                ngDialog.closeAll();

                $location.search('address', address);
                $location.search('lat', lat);
                $location.search('lng', lng);
            };

            const changePlace = function () {
                let place = autocomplete.getPlace();

                if (place.name !== elSearch.val()) {
                    place = autocomplete.getPlace();
                }

                coordinatesUtils
                    .getCoordinates(place)
                    .then(recenterOnGeometry)
                    .catch(alert.bind(window));
            };

            // Event listener for when an inputAddress is selected by the user from the drop down list
            google.maps.event.addListener(autocomplete, 'place_changed', changePlace);

            const inputSearch = element.find('input');

            element
                .find('button')
                .on('click', () => {
                    const inputString = inputSearch.val();

                    if (inputString) {
                        const fakedPlace = {
                            name: inputString
                        };

                        coordinatesUtils
                            .getCoordinates(fakedPlace)
                            .then(recenterOnGeometry)
                            .catch(alert.bind(window));
                    }
                });
        }
    };
}]);

directives.directive('findProperty', ['$animate', function ($animate) {
    var shiftElement = angular.element("<div class='open-side' id='side-toggle'><ul class='nav nav-pills nav-stacked'><li bs-tooltip='tooltip_toggle' data-type='toggle' data-placement='right' ng-click='checkSearch()'><a><i class='far fa-arrow-alt-circle-right'></i></a></li></ul></div>");
    var sidebarElement = angular.element("<div id='catSide' class='no-sidebar'><div ng-view class='sidebar-base'></div></div>");
    var firstOpen = false;
    var sumOpen = false;
    var link = function (scope, element) {
        var toggleParentClass = () => {
            element.parent().toggleClass('sidebar-active')
        }
        element.on('click', function () {
            if (scope.canToggle && scope.propClick) {
                if (!firstOpen) {
                    firstOpen = true;
                    sumOpen = true;
                    element.toggleClass('flodiv1');
                    element.toggleClass('flodiv2');
                    toggleParentClass()
                    shiftElement.toggleClass('open-side');
                    shiftElement.toggleClass('close-side');
                    shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-left');
                    shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-right');
                    sidebarElement.toggleClass('no-sidebar');
                    sidebarElement.toggleClass('sidebar');
                }
                if (element.hasClass('flodiv1') && shiftElement.hasClass('open-side')) {
                    firstOpen = !firstOpen;
                }
            }
        });
        shiftElement.on('click', function () {
            if (scope.canToggle && scope.propClick) {
                element.toggleClass('flodiv1');
                element.toggleClass('flodiv2');
                toggleParentClass()
                if (element.hasClass('flodiv2'))
                    sumOpen = true;
                else
                    sumOpen = false;
                if (!firstOpen)
                    firstOpen = true;
                shiftElement.toggleClass('close-side');
                shiftElement.toggleClass('open-side');
                shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-left');
                shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-right');
                sidebarElement.toggleClass('no-sidebar');
                sidebarElement.toggleClass('sidebar');
            }
            else {
                $animate.addClass(shiftElement, 'no-search-enter', function () {
                    $animate.removeClass(shiftElement, 'no-search-enter');
                });
            }
        });
        scope.showSummary = function () {
            if (scope.canToggle && scope.propClick) {
                if (!firstOpen)
                    firstOpen = true;
                if (!sumOpen)
                    sumOpen = !sumOpen;
                element.toggleClass('flodiv1');
                element.toggleClass('flodiv2');
                toggleParentClass()
                shiftElement.toggleClass('close-side');
                shiftElement.toggleClass('open-side');
                shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-left');
                shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-right');
                sidebarElement.toggleClass('no-sidebar');
                sidebarElement.toggleClass('sidebar');
            }

        };
        scope.closeSummary = function () {
            if (scope.canToggle && scope.propClick) {
                if (!firstOpen)
                    firstOpen = true;
                if (sumOpen)
                    sumOpen = !sumOpen;
                element.toggleClass('flodiv1');
                element.toggleClass('flodiv2');
                toggleParentClass()
                shiftElement.toggleClass('close-side');
                shiftElement.toggleClass('open-side');
                shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-left');
                shiftElement.children(0).children().children().children().toggleClass('far fa-arrow-alt-circle-right');
                sidebarElement.toggleClass('no-sidebar');
                sidebarElement.toggleClass('sidebar');
            }
        };
        scope.$on('sidebarCall', function (event) {

        });
    };

    return {
        restrict: 'E',
        replace: true,
        template: '<div class="flodiv1" id="sidebar">' +
            '<ul class="nav nav-pills nav-stacked">' +
            '<sidebar-buttons ng-repeat="category in categories" check="checkSearch()" name="{{category.name}}" on-select="select(name)"  is-selected="isSelected(category)" icon="{{category.class}}" category="categoryLayer(name)" toggle="{{category.toggle}}" searchtoggle="canToggle" proptoggle="propClick" bs-tooltip="tooltip_{{category.tooltip}}" data-placement="right" data-type="{{category.name}}" data-ng-show="{{category.show}}"></sidebar-buttons>' +
            '</ul>' +
            '</div>',
        controller: function ($scope) {
            $scope.selected = '';
            $scope.$on('openSidebar', function () {
                if (!$scope.selected) {
                    $scope.selected = $scope.categories[0].name;
                }
                if (!sumOpen) {
                    $scope.showSummary();
                }
            });
            $scope.$on('closeSidebar', function () {
                if (sumOpen) {
                    $scope.closeSummary();
                }
            });
            $scope.$on('openSidebarforDev', function () {
                $scope.showSummary();
            });
            $scope.isSelected = function (category) {
                return category.name === $scope.selected;
            };
            $scope.select = function (name) {
                console.log(name);
                $scope.selected = name;
            }
        },
        compile: function (tElem) {
            tElem.append(shiftElement);
            tElem.append(sidebarElement);

            return link;
        }
    }
}]);

directives.directive('compileInfo', function ($compile) {
    return {
        link: function ($scope, $element) {
            var onload = function () {
                $scope.$apply(function () {
                    $compile(document.getElementById("infoBox"))($scope)
                });
            };

            google.maps.event.addListener($scope.addressWindow, 'domready', function (a, b, c, d) {
                onload();
            });
        }
    }
});

directives.directive('findSearch', ['$animate', function ($animate) {
    return {
        replace: true
    }
}]);

directives.directive('warnMessage', function () {
    return {
        restrict: "E",
        replace: true,
        template: '<div class="user-alert absdiv1" ng-show="showMsg"><div class="user-alert-body">{{message}}</div></div>'
    };
});

directives.directive('zoomMessage', function () {
    return {
        restrict: "E",
        replace: true,
        template: '<div class="user-alert zoom-warning" ng-show="parcelOn"><div class="user-alert-body">{{zoomMsg}}</div></div>'
    };
});
directives.directive('unlockMessage', function () {
    return {
        restrict: "E",
        replace: true,
        template: '<div class="user-alert unlock-warning" ng-show="unlockOn"><div class="user-alert-body">{{unlockMsg}}</div></div>'
    };
});
directives.directive('devResults', function () {
    return {
        restrict: "E",
        replace: true,
        template: '<div class="user-alert dev-warning" ng-show="devResults"><div class="user-alert-body">{{devMsg}}</div></div>'
    };
});

directives.directive('areaMessage', function () {
    return {
        restrict: "E",
        replace: true,
        template: '<div class="user-alert zoom-warning" ng-show="isCovered"><div class="user-alert-body">{{areaMsg}}</div></div>'
    };
});

directives.directive('sideToggle', function () {
    return {
        replace: true,
        link: function (scope, element) {
            element.on('click', function () {
                element.toggleClass('fa fa-plus-circle');
                element.toggleClass('fa fa-minus-circle');
            });
        }
    }
});

var logTabClickEvent = function (tabName) {
    var mapOfTabEventIds = {
        'official-plan': EventTypes.CLICKED_TAB_OFFICIAL_PLAN,
        'op-citywide-toronto': EventTypes.CLICKED_TAB_URBAN_STRUCTURE,
        'by-law': EventTypes.CLICKED_TAB_ZONING_BY_LAW,
        'dev-app-toronto': EventTypes.CLICKED_TAB_DEV_APP,
        'water': EventTypes.CLICKED_TAB_WATER,
        'environment': EventTypes.CLICKED_TAB_ENVIRONMENT,
        'provincial-plan': EventTypes.CLICKED_TAB_PROVINCIAL_PLAN
    };

    EventsLoggingService.clickedTab(mapOfTabEventIds[tabName]);
};

directives.directive('sidebarButtons', ['$animate', function ($animate) {
    return {
        restrict: 'E',
        replace: true,
        scope: { check: '&', name: '@', icon: '@', category: '&', searchtoggle: '=', proptoggle: '=', onSelect: '&', isSelected: '=' },
        template: '<li ng-click="category({name: name})" ng-class="{selected: isSelected}"><a ng-class="name"><i ng-class="icon"></i></a></li>',
        link: function (scope, element) {
            element.on('click', function () {
                logTabClickEvent(scope.name);
                if (scope.searchtoggle && scope.proptoggle) {
                    scope.onSelect({ name: scope.name });
                    return true;
                } else {
                    $animate.addClass(element, 'no-search-enter', function () {
                        $animate.removeClass(element, 'no-search-enter');
                    });
                }
            });
        }
    }
}]);

directives.directive('scroll', function () {
    return {
        replace: true,
        link: function (scope, element) {
            var sb = element[0];
            var bot = angular.element(document.querySelector('.layer-bottom'));
            console.log(bot);
            element.bind('scroll', function () {

            });
            scope.changeBottom = function (change) {
                //bot.removeClass('layer-bottom-t');
                if (!change) {
                    if (bot.hasClass('layer-bottom-t')) {
                        bot.toggleClass('layer-bottom-t');
                        bot.toggleClass('layer-bottom');
                    }
                }
                else if (change) {
                    if (bot.hasClass('layer-bottom')) {
                        bot.toggleClass('layer-bottom');
                        bot.toggleClass('layer-bottom-t');
                    }
                }
            };
            scope.isOverflowed = function () {
                return sb.scrollHeight > sb.clientHeight || sb.scrollWidth > sb.clientWidth;
            };

            scope.$watch(scope.isOverflowed, function (value) {
                console.log(value);
                if (!value) {
                    scope.changeBottom(value);
                }
                else if (value) {
                    scope.changeBottom(value);
                }

            });
        }
    }
});

directives.directive('layout', function ($window) {
    return {
        restrict: 'EA',
        link: function (scope, element, attrs) {
            scope.onResize = function () {
                scope.windowHeight = $window.innerHeight;
                scope.windowWidth = $window.innerWidth;
                //console.log(scope.windowHeight+"-"+scope.windowWidth);
            };
            scope.onResize();
            angular.element($window).bind('resize', function () {
                scope.onResize();
                scope.$apply();
            });
        }
    }
});

/* Auth Directives below this comment*/

directives.directive('login', function () {
    return {
        templateUrl: 'templates/login.tpl.html'
    }
});

directives.directive('register', function () {
    return {
        templateUrl: 'templates/register.tpl.html'
    }
});

directives.directive('home', function () {
    return {
        templateUrl: 'templates/home.tpl.html'
    }
});



// WEBPACK FOOTER //
// ./public/js/directives.js